"use strict";
exports.__esModule = true;
exports.useEventHandlers = void 0;
var react_1 = require("react");
var useEventHandler = function (object, type, handler) {
    (0, react_1.useEffect)(function () {
        if (object && handler) {
            object.addEventListener(type, handler);
            return function () {
                object.removeEventListener(type, handler);
            };
        }
    }, [object, handler]);
};
var useEventHandlers = function (object, _a) {
    var onTap = _a.onTap, onPointerLeave = _a.onPointerLeave, onPointerMove = _a.onPointerMove, onPointerEnter = _a.onPointerEnter, onDragStart = _a.onDragStart, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd;
    useEventHandler(object, "tap", onTap);
    useEventHandler(object, "pointerleave", onPointerLeave);
    useEventHandler(object, "pointermove", onPointerMove);
    useEventHandler(object, "pointerenter", onPointerEnter);
    useEventHandler(object, "dragstart", onDragStart);
    useEventHandler(object, "drag", onDrag);
    useEventHandler(object, "dragend", onDragEnd);
};
exports.useEventHandlers = useEventHandlers;
